<template>
  <div class="animate-pulse flex flex-col gap-6">
    <!-- Hero -->
    <div
      class="flex flex-col sm:flex-row items-center sm:items-start gap-5 rounded-2xl border border-gray-100 p-6"
    >
      <div class="w-20 h-20 bg-gray-200 rounded-full shrink-0"></div>
      <div class="flex flex-col gap-2 w-full max-w-xs">
        <div class="h-7 bg-gray-200 rounded w-56"></div>
        <div class="flex gap-2">
          <div class="h-5 bg-gray-200 rounded w-24"></div>
          <div class="h-5 bg-gray-200 rounded w-16"></div>
        </div>
        <div class="h-4 bg-gray-200 rounded w-40"></div>
      </div>
    </div>

    <!-- Stat cards -->
    <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
      <div
        v-for="n in 4"
        :key="n"
        class="flex items-center gap-3 rounded-2xl border border-gray-100 px-4 py-3"
      >
        <div class="w-10 h-10 bg-gray-200 rounded-lg shrink-0"></div>
        <div class="flex flex-col gap-1.5 w-full">
          <div class="h-3 bg-gray-200 rounded w-16"></div>
          <div class="h-5 bg-gray-200 rounded w-20"></div>
        </div>
      </div>
    </div>

    <!-- Content grid -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div v-for="col in 2" :key="col" class="rounded-2xl border border-gray-100 p-6">
        <div class="h-5 bg-gray-200 rounded w-40 mb-6"></div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div v-for="n in 4" :key="n" class="flex flex-col gap-1.5">
            <div class="h-3 bg-gray-200 rounded w-24"></div>
            <div class="h-5 bg-gray-200 rounded w-32"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
